
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { TravelPhilosophySection } from './components/TravelPhilosophySection';
import { ExperienceSection } from './components/ExperienceSection';
import { ServicesSection } from './components/ServicesSection';
import { AdditionalServicesSection } from './components/AdditionalServicesSection';
import { TravelWithUsSection } from './components/TravelWithUsSection';
//import { ItineraryForm } from './components/ItineraryForm';
import { NewsletterSection } from './components/NewsletterSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <TravelPhilosophySection />
        <ExperienceSection />
        <ServicesSection />
        <AdditionalServicesSection />
        <TravelWithUsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
